export const categories = [
  {
    slug: 'dianshi',
    name: '电视剧',
    icon: 'ri-tv-line',
    description: '热门电视剧、经典剧集、最新连载，一站式追剧平台',
    count: 3280,
  },
  {
    slug: 'dianying',
    name: '电影',
    icon: 'ri-film-line',
    description: '院线大片、经典影片、独立佳作，畅享影院级观影体验',
    count: 5620,
  },
  {
    slug: 'zongyi',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺、搞笑节目、真人秀，欢乐不间断',
    count: 2150,
  },
  {
    slug: 'dongman',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '日漫、国漫、剧场版，二次元世界精彩纷呈',
    count: 4890,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然、历史、科技、人文，探索世界的每一个角落',
    count: 1560,
  },
  {
    slug: 'yinyue',
    name: '音乐',
    icon: 'ri-music-line',
    description: 'MV、演唱会、音乐节目，视听双重享受',
    count: 980,
  },
];

export const allVideos = [
  {
    id: 1,
    title: '山河锦绣 - 大型古装传奇剧',
    category: 'dianshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20drama%20scene%20with%20traditional%20ancient%20architecture%20and%20flowing%20silk%20costumes%2C%20soft%20warm%20cinematic%20lighting%2C%20epic%20landscape%20background%20with%20mountains%20and%20mist%2C%20professional%20film%20photography%20style&width=640&height=360&seq=video-thumb-01&orientation=landscape',
    duration: '45:32',
    views: '1280万',
    rating: 9.2,
    date: '2026-08-10',
    description: '一部展现中华传统文化魅力的史诗巨制，讲述了乱世中英雄儿女的传奇故事。精美的服化道、宏大的场景布置，带给观众沉浸式的观剧体验。',
    tags: ['古装', '传奇', '历史', '史诗'],
  },
  {
    id: 2,
    title: '星际穿越 - 科幻冒险巨制',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20space%20scene%20with%20distant%20galaxies%20and%20nebula%20colors%2C%20spacecraft%20silhouette%20against%20starfield%2C%20deep%20cosmic%20atmosphere%20with%20dramatic%20lighting%2C%20professional%20film%20photography&width=640&height=360&seq=video-thumb-02&orientation=landscape',
    duration: '2:28:15',
    views: '3560万',
    rating: 9.5,
    date: '2026-08-08',
    description: '当人类面临生存危机，一群勇敢的探险家踏上了穿越虫洞的星际旅程。震撼的视觉效果与深刻的人文思考完美融合。',
    tags: ['科幻', '冒险', '太空', '史诗'],
  },
  {
    id: 3,
    title: '欢乐喜剧人 - 爆笑综艺合集',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20variety%20show%20stage%20with%20warm%20spotlights%20and%20cheerful%20atmosphere%2C%20entertaining%20performance%20set%20design%2C%20vibrant%20and%20energetic%20visual%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape',
    duration: '1:32:40',
    views: '890万',
    rating: 8.9,
    date: '2026-08-09',
    description: '汇聚全国顶尖喜剧人才，每期带来令人捧腹的精彩表演。让欢笑成为你生活中不可或缺的一部分。',
    tags: ['喜剧', '综艺', '搞笑', '娱乐'],
  },
  {
    id: 4,
    title: '灵笼 - 国产科幻动画巅峰',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20futuristic%20anime%20style%20scene%20with%20mechanical%20structures%20and%20atmospheric%20lighting%2C%20post%20apocalyptic%20aesthetic%20with%20detailed%20character%20silhouettes%2C%20high%20quality%203D%20animation%20render%20style&width=640&height=360&seq=video-thumb-04&orientation=landscape',
    duration: '24:18',
    views: '2150万',
    rating: 9.6,
    date: '2026-08-12',
    description: '在末日废土世界中，幸存者们为生存而战的壮丽史诗。国产动画的里程碑之作，每一帧都是壁纸级别的画面。',
    tags: ['科幻', '动画', '国产', '末日'],
  },
  {
    id: 5,
    title: '地球脉动 - 自然纪录片巨作',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20diverse%20wildlife%20in%20natural%20habitat%2C%20golden%20sunlight%20through%20forest%20canopy%2C%20pristine%20wilderness%20landscape%2C%20professional%20nature%20photography%20with%20vivid%20colors&width=640&height=360&seq=video-thumb-05&orientation=landscape',
    duration: '52:10',
    views: '680万',
    rating: 9.8,
    date: '2026-08-05',
    description: '从极地冰原到热带雨林，从深邃海洋到广袤沙漠，镜头带您领略地球上最壮丽的自然奇观。',
    tags: ['自然', '动物', '环保', '探索'],
  },
  {
    id: 6,
    title: '华语金曲盛典 - 2026年度演唱会',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20lighting%20and%20laser%20effects%2C%20massive%20crowd%20silhouettes%2C%20epic%20live%20music%20performance%20atmosphere%2C%20professional%20concert%20photography%20with%20warm%20color%20tones&width=640&height=360&seq=video-thumb-06&orientation=landscape',
    duration: '2:05:30',
    views: '1560万',
    rating: 9.1,
    date: '2026-08-07',
    description: '华语乐坛年度盛典，群星璀璨，经典与新声交织。超高清录制，让你仿佛置身现场。',
    tags: ['音乐', '演唱会', '华语', '现场'],
  },
  {
    id: 7,
    title: '大明风华 - 权谋史诗剧',
    category: 'dianshi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ming%20dynasty%20imperial%20palace%20interior%20with%20ornate%20golden%20decorations%20and%20traditional%20Chinese%20furnishings%2C%20dramatic%20candlelight%20and%20shadow%20play%2C%20cinematic%20historical%20drama%20aesthetic&width=640&height=360&seq=video-thumb-07&orientation=landscape',
    duration: '42:15',
    views: '980万',
    rating: 8.8,
    date: '2026-08-11',
    description: '明朝宫廷的权力博弈，忠臣与奸佞的生死较量。剧本考究，演员演技在线，是不可多得的精品历史剧。',
    tags: ['历史', '宫廷', '权谋', '明朝'],
  },
  {
    id: 8,
    title: '深海迷踪 - 悬疑惊悚大片',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20underwater%20scene%20with%20dark%20blue%20tones%20and%20ethereal%20light%20rays%20penetrating%20water%2C%20suspenseful%20atmosphere%2C%20submarine%20silhouette%20in%20distance%2C%20cinematic%20thriller%20aesthetic&width=640&height=360&seq=video-thumb-08&orientation=landscape',
    duration: '1:48:22',
    views: '2230万',
    rating: 8.7,
    date: '2026-08-06',
    description: '深海科考队在一次例行任务中意外发现不明生物，一场惊心动魄的深海求生之旅就此展开。',
    tags: ['悬疑', '惊悚', '深海', '冒险'],
  },
  {
    id: 9,
    title: '美食大冒险 - 环球美食综艺',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20gourmet%20food%20display%20on%20rustic%20wooden%20table%20with%20warm%20ambient%20lighting%2C%20international%20cuisine%20variety%2C%20appetizing%20food%20photography%20style%20with%20shallow%20depth%20of%20field&width=640&height=360&seq=video-thumb-09&orientation=landscape',
    duration: '58:40',
    views: '720万',
    rating: 9.0,
    date: '2026-08-10',
    description: '跟随美食达人走遍全球，探寻各地特色美食背后的故事。色香味俱全，让味蕾来一场环球旅行。',
    tags: ['美食', '旅行', '文化', '综艺'],
  },
  {
    id: 10,
    title: '剑道无双 - 热血少年动画',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20Japanese%20anime%20style%20battle%20scene%20with%20sword%20warrior%20silhouette%20against%20sunset%20sky%2C%20dramatic%20clouds%20and%20energy%20effects%2C%20vibrant%20action%20animation%20aesthetic%20with%20warm%20color%20palette&width=640&height=360&seq=video-thumb-10&orientation=landscape',
    duration: '23:45',
    views: '1890万',
    rating: 9.3,
    date: '2026-08-12',
    description: '少年剑客踏上修行之路，在一次次战斗中成长蜕变。热血沸腾的战斗场面，感人至深的友情羁绊。',
    tags: ['热血', '战斗', '成长', '动画'],
  },
  {
    id: 11,
    title: '宇宙探秘 - 天文科学纪录片',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20outer%20space%20scene%20with%20colorful%20galaxy%20and%20nebula%20formations%2C%20planets%20and%20stars%20in%20deep%20cosmos%2C%20scientific%20visualization%20style%20with%20vivid%20cosmic%20colors&width=640&height=360&seq=video-thumb-11&orientation=landscape',
    duration: '48:30',
    views: '450万',
    rating: 9.4,
    date: '2026-08-04',
    description: '走进浩瀚宇宙，探索星系诞生、黑洞奥秘与地外生命的可能性。用最前沿的科学视角，解读宇宙之谜。',
    tags: ['天文', '科学', '宇宙', '探索'],
  },
  {
    id: 12,
    title: '民谣之夜 - 独立音乐现场',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20folk%20music%20live%20performance%20in%20cozy%20candlelit%20venue%2C%20guitarist%20silhouette%20on%20small%20stage%2C%20warm%20amber%20lighting%2C%20atmospheric%20music%20photography&width=640&height=360&seq=video-thumb-12&orientation=landscape',
    duration: '1:15:20',
    views: '320万',
    rating: 9.0,
    date: '2026-08-03',
    description: '聆听最纯粹的民谣之音，独立音乐人用真挚的旋律讲述生活与梦想。一杯清茶，一首好歌，足以慰藉心灵。',
    tags: ['民谣', '独立音乐', '现场', '文艺'],
  },
];

export const faqList = [
  {
    q: '一起草在线观看需要注册账号吗？',
    a: '不需要！一起草在线观看平台完全免费开放，无需注册即可畅享所有高清视频内容。我们致力于为用户提供最便捷的观看体验。',
  },
  {
    q: '一起草在线观看支持哪些设备？',
    a: '一起草在线观看支持电脑、平板、手机等多种终端设备。无论您使用 Windows、Mac、iOS 还是 Android，都可以流畅观看高清视频。',
  },
  {
    q: '视频加载速度慢怎么办？',
    a: '一起草在线观看采用先进的 CDN 加速技术，自动为您匹配最优节点。如遇卡顿，建议检查网络连接或切换画质设置。',
  },
  {
    q: '可以下载视频到本地观看吗？',
    a: '一起草在线观看主要提供在线播放服务。部分内容支持缓存到本地，方便您在无网络环境下观看。具体以播放页面显示为准。',
  },
  {
    q: '视频画质最高支持多少？',
    a: '一起草在线观看支持标清、高清、超清多种画质选择，部分热门内容最高支持 4K 超高清画质，带给您极致的视觉享受。',
  },
  {
    q: '如何向我们反馈问题或建议？',
    a: '您可以通过「关于我们」页面的联系方式与我们沟通，或发送邮件至 support@feixuehuihua.cn。您的每一条反馈我们都非常重视。',
  },
];

export const features = [
  { icon: 'ri-4k-line', title: '超清画质', desc: '支持4K高清播放，每一帧都清晰细腻' },
  { icon: 'ri-speed-up-line', title: '极速加载', desc: 'CDN全球加速，秒开不卡顿' },
  { icon: 'ri-smartphone-line', title: '多端适配', desc: '电脑手机平板全覆盖，随时随地观看' },
  { icon: 'ri-vip-crown-line', title: '完全免费', desc: '无需付费，无需注册，即点即看' },
];

export const stats = [
  { value: '10万+', label: '视频资源' },
  { value: '5000万+', label: '月活用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '4.9', label: '用户评分' },
];